"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateGumballTransformation = exports.Gumball = void 0;
const Gumball_1 = require("./implementation/Gumball");
Object.defineProperty(exports, "Gumball", { enumerable: true, get: function () { return Gumball_1.Gumball; } });
const updateGumballTransformation_1 = require("./implementation/updateGumballTransformation");
Object.defineProperty(exports, "updateGumballTransformation", { enumerable: true, get: function () { return updateGumballTransformation_1.updateGumballTransformation; } });
//# sourceMappingURL=index.js.map